import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import invariant from 'invariant';
import isFunction from 'lodash/isFunction';
import ensureStrategy from './ensureStrategy';
export default function resolveStrategy(ctx, strategyType, strategy) {
  var strategies = ctx.strategies;

  var _ensureStrategy = ensureStrategy(strategy),
      _ensureStrategy2 = _slicedToArray(_ensureStrategy, 2),
      strategyIdent = _ensureStrategy2[0],
      strategyArgs = _ensureStrategy2[1];

  var handler = strategies[strategyType][strategyIdent];
  invariant(isFunction(handler), "Strategy ".concat(strategy, " of type ").concat(strategyType, " not found or handler is not a function."));
  return [handler, strategyArgs];
}